// extracted by mini-css-extract-plugin
export default {"image":"a8-z","loaded":"b8-z","placeholder":"c8-z"};